@if (selectedService) {
  <section class="flex min-h-screen flex-col">
    <div class="w-full flex-1 p-6">
      <!-- Back link (mobile) -->
      @if (browserSize === 'small') {
        <a
          [routerLink]="['/services']"
          class="mb-4 inline-flex items-center gap-1 text-sm"
        >
          <mat-icon class="text-base">arrow_back</mat-icon>
          Back to Services
        </a>
      }

      <!-- Header: title + status -->
      <div class="flex items-center justify-between">
        <div class="items-center gap-1.5">
          <h2>{{ selectedService.Name | uppercase }}</h2>
        </div>
        <span
          class="rounded-full px-3.5 py-2 text-base font-bold uppercase"
          [ngClass]="{
            'bg-green-50 text-green-700':
              selectedService.Status__c === 'In Service',
            'bg-yellow-50 text-yellow-700':
              selectedService.Status__c === 'New' ||
              selectedService.Status__c === 'Pending',
            'bg-red-50 text-red-600':
              selectedService.Status__c === 'Canceled' ||
              selectedService.Status__c === 'Disconnected',
          }"
        >
          {{
            selectedService.Status__c === 'New'
              ? 'Pending'
              : selectedService.Status__c
          }}
        </span>
      </div>

      <!-- Location -->
      <div class="flex items-center gap-1.5">
        <span>
          @if (selectedService.CustomerLocationAlias) {
            {{ selectedService.CustomerLocationAlias }} ·
          }
          {{ selectedService.Z_Location__r.Name }}
        </span>
        @if (
          selectedService.Status__c === 'In Service' &&
          selectedService.BanLookupId
        ) {
          <a
            (click)="onEditLocationName(selectedService)"
            class="cursor-pointer rounded-full bg-blue-50 pl-2 pr-1 pt-1 transition-colors hover:bg-gray-100"
          >
            <mat-icon class="text-base text-blue-600">edit</mat-icon>
          </a>
        }
      </div>

      <div
        class="text-[lg mt-4 border-b-[1px] border-gray-100 font-medium uppercase tracking-widest"
      >
        {{ selectedService.RecordType.Name }}
      </div>

      <!-- Meta grid -->
      <div class="mb-4 grid grid-cols-3 overflow-hidden rounded-xl border-0">
        <!-- Bandwidth (with utilization link) -->
        @if (selectedService.Bandwidth_Downstream__c) {
          <div class="border-0 py-3 pr-4">
            <p class="mb-1 text-[10px] uppercase tracking-widest text-gray-600">
              Bandwidth
            </p>
            <div class="flex items-center gap-1.5">
              <span
                class="inline-flex items-center rounded-full bg-blue-50 px-2.5 py-1 text-sm font-medium text-blue-600"
              >
                {{ selectedService.Bandwidth_Downstream__c }}
                @if (selectedService.Asymmetrical_Bandwidth__c) {
                  / {{ selectedService.Bandwidth_Upstream__c }}
                }
              </span>
            </div>
            @if (selectedService.Status__c === 'In Service') {
              <a
                routerLink="/services/p95-utilization"
                *ngxPermissionsOnly="Permission.NITEL_IQ_PARTICIPANT"
                class="mt-0.5 inline-block text-xs hover:underline"
              >
                View 95th percentile report →
              </a>
            }
          </div>
        }

        <!-- Vendor -->
        @if (selectedService.Vendor__r) {
          <div class="border-0 py-3 pr-4">
            <p class="mb-1 text-[10px] uppercase tracking-widest text-gray-600">
              Vendor
            </p>
            <p class="text-sm font-medium text-gray-800">
              {{
                selectedService.Vendor__r.Display_Alias__c ||
                  selectedService.Vendor__r.Name
              }}
            </p>
          </div>
        }

        <!-- Connector -->
        @if (selectedService.Connector_Type_Z_Location__c) {
          <div class="border-0 py-3 pr-4">
            <p class="mb-1 text-[10px] uppercase tracking-widest text-gray-600">
              Connector
            </p>
            <p class="text-sm font-medium text-gray-800">
              {{ selectedService.Connector_Type_Z_Location__c }}
            </p>
          </div>
        }

        <!-- Term -->
        @if (selectedService.Term__c) {
          <div class="border-0 py-3 pr-4">
            <p class="mb-1 text-[10px] uppercase tracking-widest text-gray-600">
              Term
            </p>
            <p class="text-sm font-medium text-gray-800">
              {{ selectedService.Term__c }} months
            </p>
          </div>
        }

        <!-- Start -->
        <div class="border-0 py-3 pr-4">
          <p class="mb-1 text-[10px] uppercase tracking-widest text-gray-600">
            Start
          </p>
          <p class="text-sm font-medium text-gray-800">
            {{ selectedService.Start_Of_Service__c | date: 'MMM d, yyyy' }}
          </p>
        </div>

        <!-- End -->
        <div class="border-0 py-3 pr-4">
          <p class="mb-1 text-[10px] uppercase tracking-widest text-gray-600">
            End
          </p>
          <p class="text-sm font-medium text-gray-800">
            {{ selectedService.Current_Term_End_Date__c | date: 'MMM d, yyyy' }}
          </p>
        </div>
      </div>

      <!-- Billing components -->
      @if (selectedService.Components__r) {
        <div class="mb-4">
          <app-service-billing
            [components]="selectedService.Components__r.records"
          ></app-service-billing>
        </div>
      }

      <!-- Monthly total + CTA -->
      <div class="flex items-center justify-end">
        <p class="text-xl font-medium text-gray-900">
          {{
            selectedService.MRR__c
              ? (selectedService.MRR__c | currency)
              : '$0.00'
          }}
          <span class="text-sm font-normal text-gray-600">/mo</span>
        </p>
      </div>
      @if (selectedService.Status__c === 'In Service') {
        <div class="mt-12 flex w-full flex-col items-center gap-1">
          <button
            *ngxPermissionsOnly="Permission.TICKETING_WRITE"
            (click)="onCreateTicket()"
            class="btn-secondary w-1/2 justify-center"
          >
            Create ticket
          </button>

          <p class="text-sm text-gray-600">Report an issue with this service</p>
        </div>
      }
    </div>
  </section>
}
